import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DataTable, columnTypes as colType, h2hStk } from 'yankees-react-utils';

const StyledLabel = styled.div`
    font-weight: bold;
    text-align: left;
    padding-bottom: 5px;
`;

const columns = (translate) => [
    { id: 'catcher', title: translate('baseball.catcher_one'), transform: (row) => row.catcherName, type: colType.TEXT },
    { id: 'taken', title: translate('sections.post-game.receiving.taken-pitches'), transform: (row) => row.pitches },
    { id: 'actual', title: translate('sections.post-game.receiving.actual-strikes'), transform: (row) => row.strikes },
    { id: 'expected', title: translate('sections.post-game.receiving.expected-strikes'), transform: (row) => row.pstrikes, precision: 1 },
    { id: 'extra', title: translate('sections.post-game.receiving.extra-strikes'), transform: (row) => (row.strikes - row.pstrikes), precision: 1 },
    { id: 'adjusted', title: translate('sections.post-game.receiving.adjusted-h2h'), transform: (row) => row.headToHead, precision: 1 },
];

const ReceivingTable = ({ player, headToHeadData }) => {
    const { t: translate } = useTranslation();
    const { pitches, strikes, pstrikes, opp_pitches, opp_strikes, opp_pstrikes } = headToHeadData;
    const headToHead = h2hStk(strikes, pstrikes, opp_strikes, opp_pstrikes, pitches, opp_pitches, pitches);
    const headToHeadRows = [
        { catcherName: `${player.UsesName} ${player.LastName}`, pitches, strikes, pstrikes, headToHead },
        { catcherName: translate('baseball.opponent'), pitches: opp_pitches, strikes: opp_strikes, pstrikes: opp_pstrikes, headToHead: null },
    ];

    return (
        <>
            <StyledLabel>*{translate('sections.post-game.receiving.strike-probability-warning')}</StyledLabel>
            <DataTable columns={columns(translate)} rows={headToHeadRows} />
        </>
    );
};

ReceivingTable.propTypes = {
    player: PropTypes.shape({
        PlayerID: PropTypes.number,
        UsesName: PropTypes.string,
        LastName: PropTypes.string,
    }).isRequired,
    headToHeadData: PropTypes.shape({
        pitches: PropTypes.number,
        strikes: PropTypes.number,
        pstrikes: PropTypes.number,
        opp_pitches: PropTypes.number,
        opp_strikes: PropTypes.number,
        opp_pstrikes: PropTypes.number,
    }).isRequired,
};

export default ReceivingTable;
